import styled from "styled-components"

export const FlexContainer = styled.div<{
  isDarkMode?: boolean,
  justifyContent?: string,
  width?: string,
  height?: string
  padding?: string
  debugBorder?: boolean
}>`
  display: flex;
  background-color: ${(props) => props.isDarkMode ? '#1f1f1f' : 'white'};
  color: ${(props) => props.isDarkMode ? 'white' : 'black'};
  height: ${(props) => props.height ? props.height : '100%'};
  width: ${(props) => props.width ? props.width : '100%'};
  justify-content: ${(props) => props.justifyContent ? props.justifyContent : 'center'};
  padding: ${(props) => props.padding ? props.padding : '0'};
  border: ${(props) => props.debugBorder ? '3px solid purple' : 'none'};
`

export const FlexRow = styled.div<{
  justifyContent?: JustifyContentValues,
  alignItems?: AlignItemsValues,
  alignSelf?: string,
  width?: string,
  minHeight?: string
  height?: string
  padding?: string
  margin?: string
  debugBorder?: boolean
  flexWrap?: boolean
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${(props) => props.justifyContent ? props.justifyContent : 'center'};
  align-items: ${(props) => props.alignItems ? props.alignItems : 'center'};
  align-self: ${(props) => props.alignSelf ? props.alignSelf : ''};
  height: ${(props) => props.height ? props.height : '100%'};
  min-height: ${(props) => props.minHeight ? props.minHeight : '0'};
  width: ${(props) => props.width ? props.width : '100%'};
  padding: ${(props) => props.padding ? props.padding : '0'};
  margin: ${(props) => props.margin ? props.margin : '0'};
  border: ${(props) => props.debugBorder ? '3px solid cyan' : 'none'};
  flex-wrap: ${(props) => props.flexWrap ? 'wrap' : 'nowrap'};
`

export const FlexColumn = styled.div<{
  justifyContent?: JustifyContentValues,
  alignItems?: AlignItemsValues,
  width?: string,
  height?: string
  minHeight?: string
  padding?: string
  margin?: string
  debugBorder?: boolean
  flexWrap?: boolean
}>`
  display: flex;
  flex-direction: column;
  align-items: ${(props) => props.alignItems ? props.alignItems : 'center'};
  justify-content: ${(props) => props.justifyContent ? props.justifyContent : 'center'};
  height: ${(props) => props.height ? props.height : '100%'};
  min-height: ${(props) => props.minHeight ? props.minHeight : '0'};
  width: ${(props) => props.width ? props.width : '100%'};
  padding: ${(props) => props.padding ? props.padding : '0'};
  margin: ${(props) => props.margin ? props.margin : '0'};
  border: ${(props) => props.debugBorder ? '3px solid pink' : 'none'};
  flex-wrap: ${(props) => props.flexWrap ? 'wrap' : 'nowrap'};
`

type JustifyContentValues = 'flex-start' | 'flex-end' | 'center' | 'space-between' | 'space-around' | 'space-evenly'
type AlignItemsValues = 'flex-start' | 'flex-end' | 'center' | 'baseline' | 'stretch'